import type { CartItem } from "../cart/types";
import type { ShippingAddress } from "./CheckoutPage";

const STORAGE_KEY = "pm_stripe_checkout_pending";

export interface PendingStripeCheckout {
    shipping: ShippingAddress;
    items: CartItem[];
    subtotal: number;
    currency: string;
    transactionId?: string;
    savedAt: number;
}

export function savePendingStripeCheckout(data: Omit<PendingStripeCheckout, "savedAt">): void {
    try {
        sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ ...data, savedAt: Date.now() }),
        );
    } catch {
        /* ignore quota / private mode */
    }
}

export function readPendingStripeCheckout(): PendingStripeCheckout | null {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as PendingStripeCheckout;
        if (!parsed?.shipping || !Array.isArray(parsed.items)) return null;
        // Expire after 2 hours
        if (Date.now() - (parsed.savedAt || 0) > 2 * 60 * 60 * 1000) {
            clearPendingStripeCheckout();
            return null;
        }
        return parsed;
    } catch {
        return null;
    }
}

export function clearPendingStripeCheckout(): void {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        /* ignore */
    }
}
